import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL as string
const supabaseKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string

const projectRef = new URL(supabaseUrl).hostname.split('.')[0]
const AUTH_STORAGE_KEY = `sb-${projectRef}-auth-token`
const LEGACY_COOKIE_CHUNKS = 32

function expireLegacyCookie(name: string) {
  if (typeof document === 'undefined') return
  const secure = window.location.protocol === 'https:' ? '; Secure' : ''
  document.cookie = `${name}=; Path=/; SameSite=Lax; Max-Age=0${secure}`
  if (window.location.hostname.endsWith('veltica.com')) {
    document.cookie = `${name}=; Path=/; SameSite=Lax; Max-Age=0; Domain=.veltica.com${secure}`
  }
}

/**
 * Borra la sesión guardada aquí, sin preguntarle a nadie.
 *
 * Existe porque `supabase.auth.signOut()` puede no contestar nunca: antes de
 * tomar su candado espera a `initializePromise`, que a su vez puede estar
 * esperando un refresco de token que no vuelve —el `fetch` de la librería no
 * lleva plazo—. Cerrar sesión no puede depender de eso, así que el borrado de
 * verdad se hace aquí, que es síncrono y no puede colgarse, y `signOut` queda
 * como cortesía para lo demás que hace.
 */
export function clearStoredSession() {
  if (typeof window === 'undefined') return
  try { window.localStorage.removeItem(AUTH_STORAGE_KEY) } catch { /* almacenamiento bloqueado */ }
  try { window.sessionStorage.removeItem(AUTH_STORAGE_KEY) } catch { /* íd. */ }
  clearLegacySharedSession()
}

/** The editor must never adopt the dashboard's old refresh token. */
export function clearLegacySharedSession() {
  if (typeof window === 'undefined') return
  expireLegacyCookie(AUTH_STORAGE_KEY)
  for (let index = 0; index < LEGACY_COOKIE_CHUNKS; index += 1) {
    expireLegacyCookie(`${AUTH_STORAGE_KEY}.${index}`)
  }
}

export const supabase = createClient(supabaseUrl, supabaseKey, {
  auth: {
    storageKey: AUTH_STORAGE_KEY,
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
})
